import combineReducers from 'combine-reducers-global-state';
import types from './types';

const MIN_SEARCH_LENGTH = 2;

const willFetchMembers = (payload) => (payload?.search || '').length >= MIN_SEARCH_LENGTH;

const permissions = (state = [], { type, payload }) => {
  switch (type) {
    case types.fetchSuperpowersSuccess:
      return payload.permissions || [];
    default:
      return state;
  }
};

const loaded = (state = false, { type }) => {
  switch (type) {
    case types.fetchSuperpowersSuccess:
      return true;
    case types.fetchSuperpowersFailure:
      return false;
    default:
      return state;
  }
};

const error = (state = false, { type }) => {
  switch (type) {
    case types.fetchSuperpowersFailure:
      return true;
    case types.fetchSuperpowers:
      return false;
    default:
      return state;
  }
};

const membersResults = (state = [], { type, payload }) => {
  switch (type) {
    case types.findMembersSuccess:
      return payload.data;
    case types.findMembers:
      return willFetchMembers(payload) ? state : [];
    default:
      return state;
  }
};

const membersLoading = (state = false, { type, payload }) => {
  switch (type) {
    case types.findMembers:
      return willFetchMembers(payload);
    case types.findMembersSuccess:
    case types.findMembersFailure:
      return false;
    default:
      return state;
  }
};

const membersMeta = (state = {}, { type, payload }) => {
  switch (type) {
    case types.findMembersSuccess:
      return payload.meta;
    case types.findMembers:
      return willFetchMembers(payload) ? state : {};
    default:
      return state;
  }
};

const memberDetailById = (state = {}, { type, payload }) => {
  switch (type) {
    case types.getMemberSuccess:
      return { ...state, [payload.id]: payload };
    default:
      return state;
  }
};

const downloadsList = (state = [], { type, payload }) => {
  switch (type) {
    case types.getDownloadsSuccess:
      return payload;
    default:
      return state;
  }
};

const downloadsLoading = (state = false, { type }) => {
  switch (type) {
    case types.getDownloads:
      return true;
    case types.getDownloadsSuccess:
    case types.getDownloadsFailure:
      return false;
    default:
      return state;
  }
};

const downloadingKey = (state = null, { type, payload }) => {
  switch (type) {
    case types.downloadFile:
      return `${payload.key}:${payload.format}`;
    case types.downloadFileSuccess:
    case types.downloadFileFailure:
      return null;
    default:
      return state;
  }
};

const superpowersReducers = combineReducers({
  permissions,
  loaded,
  error,
  membersResults,
  membersLoading,
  membersMeta,
  memberDetailById,
  downloadsList,
  downloadsLoading,
  downloadingKey,
});

export default { superpowers: superpowersReducers };
